// hooks/useCouponConfig.ts
import { EnableCouponRemoteConfig, remoteConfig } from 'configs/firebaseConfig';
import { fetchAndActivate, getValue } from 'firebase/remote-config';
import { useEffect, useState } from 'react';

interface CouponConfig {
  enable: boolean;
  coupon_code: string;
  discount_percentage: number;
  start_time: number; // Optional, if applicable
  end_time: number; // Optional, if applicable
}

// Note: The data is read from indexed db, call to firebase server is made only when the data is not available in indexed db, expired / 1 hour has passed

export const useCouponConfig = () => {
  const [coupon, setCoupon] = useState<CouponConfig | null>(null);
  const [isRemoteConfigFetched, setIsRemoteConfigFetched] = useState(false);

  useEffect(() => {
    const fetchCouponConfig = async () => {
      try {
        await fetchAndActivate(remoteConfig);
        const configStr = getValue(
          remoteConfig,
          EnableCouponRemoteConfig
        ).asString();
        const parsed: CouponConfig = JSON.parse(configStr);
        setCoupon(parsed);
        setIsRemoteConfigFetched(true);
      } catch (err) {
        console.error('Remote Config error:', err);
        setCoupon(null);
        setIsRemoteConfigFetched(true);
      }
    };

    fetchCouponConfig();
  }, []);

  return { coupon, isRemoteConfigFetched };
};
